const services = {
  async sendEvent(payload) {
    const tracr = JSON.parse(localStorage.getItem("tracr"));
    const { apiUrl, appKey } = tracr;

    return fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-app-key": appKey,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
      })
      .catch((error) => {
        console.error("[Tracr] Error sending event:", error);
      });
  },
};

export default services;
